// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--3vWjx"};